import { Ability } from "./ability";

const ability_list = [
    {
        "id": 1,
        "name_ja": "あくしゅう",
        "name_en": "Stench",
    },
    {
        "id": 2,
        "name_ja": "あめふらし",
        "name_en": "Drizzle",
    },
    {
        "id": 3,
        "name_ja": "かそく",
        "name_en": "Speed Boost",
    },
    {
        "id": 4,
        "name_ja": "カブトアーマー",
        "name_en": "Battle Armor",
    },
    {
        "id": 5,
        "name_ja": "がんじょう",
        "name_en": "Sturdy",
    },
    {
        "id": 6,
        "name_ja": "しめりけ",
        "name_en": "Damp",
    },
    {
        "id": 7,
        "name_ja": "じゅうなん",
        "name_en": "Limber",
    },
    {
        "id": 8,
        "name_ja": "すながくれ",
        "name_en": "Sand Veil",
    },
    {
        "id": 9,
        "name_ja": "せいでんき",
        "name_en": "Static",
    },
    {
        "id": 10,
        "name_ja": "ちくでん",
        "name_en": "Volt Absorb",
    },
    {
        "id": 11,
        "name_ja": "ちょすい",
        "name_en": "Water Absorb",
    },
    {
        "id": 12,
        "name_ja": "どんかん",
        "name_en": "Oblivious",
    },
    {
        "id": 13,
        "name_ja": "ノーてんき",
        "name_en": "Cloud Nine",
    },
    {
        "id": 14,
        "name_ja": "ふくがん",
        "name_en": "Compound Eyes",
    },
    {
        "id": 15,
        "name_ja": "ふみん",
        "name_en": "Insomnia",
    },
    {
        "id": 16,
        "name_ja": "へんしょく",
        "name_en": "Color Change",
    },
    {
        "id": 17,
        "name_ja": "めんえき",
        "name_en": "Immunity",
    },
    {
        "id": 18,
        "name_ja": "もらいび",
        "name_en": "Flash Fire",
    },
    {
        "id": 19,
        "name_ja": "りんぷん",
        "name_en": "Shield Dust",
    },
    {
        "id": 20,
        "name_ja": "マイペース",
        "name_en": "Own Tempo",
    },
    {
        "id": 21,
        "name_ja": "きゅうばん",
        "name_en": "Suction Cups",
    },
    {
        "id": 22,
        "name_ja": "いかく",
        "name_en": "Intimidate",
    },
    {
        "id": 23,
        "name_ja": "かげふみ",
        "name_en": "Shadow Tag",
    },
    {
        "id": 24,
        "name_ja": "さめはだ",
        "name_en": "Rough Skin",
    },
    {
        "id": 25,
        "name_ja": "ふしぎなまもり",
        "name_en": "Wonder Guard",
    },
    {
        "id": 26,
        "name_ja": "ふゆう",
        "name_en": "Levitate",
    },
    {
        "id": 27,
        "name_ja": "ほうし",
        "name_en": "Effect Spore",
    },
    {
        "id": 28,
        "name_ja": "シンクロ",
        "name_en": "Synchronize",
    },
    {
        "id": 29,
        "name_ja": "クリアボディ",
        "name_en": "Clear Body",
    },
    {
        "id": 30,
        "name_ja": "しぜんかいふく",
        "name_en": "Natural Cure",
    },
    {
        "id": 31,
        "name_ja": "ひらいしん",
        "name_en": "Lightning Rod",
    },
    {
        "id": 32,
        "name_ja": "てんのめぐみ",
        "name_en": "Serene Grace",
    },
    {
        "id": 33,
        "name_ja": "すいすい",
        "name_en": "Swift Swim",
    },
    {
        "id": 34,
        "name_ja": "ようりょくそ",
        "name_en": "Chlorophyll",
    },
    {
        "id": 35,
        "name_ja": "はっこう",
        "name_en": "Illuminate",
    },
    {
        "id": 36,
        "name_ja": "トレース",
        "name_en": "Trace",
    },
    {
        "id": 37,
        "name_ja": "ちからもち",
        "name_en": "Huge Power",
    },
    {
        "id": 38,
        "name_ja": "どくのトゲ",
        "name_en": "Poison Point",
    },
    {
        "id": 39,
        "name_ja": "せいしんりょく",
        "name_en": "Inner Focus",
    },
    {
        "id": 40,
        "name_ja": "マグマのよろい",
        "name_en": "Magma Armor",
    },
    {
        "id": 41,
        "name_ja": "みずのベール",
        "name_en": "Water Veil",
    },
    {
        "id": 42,
        "name_ja": "じりょく",
        "name_en": "Magnet Pull",
    },
    {
        "id": 43,
        "name_ja": "ぼうおん",
        "name_en": "Soundproof",
    },
    {
        "id": 44,
        "name_ja": "あめうけざら",
        "name_en": "Rain Dish",
    },
    {
        "id": 45,
        "name_ja": "すなおこし",
        "name_en": "Sand Stream",
    },
    {
        "id": 46,
        "name_ja": "プレッシャー",
        "name_en": "Pressure",
    },
    {
        "id": 47,
        "name_ja": "あついしぼう",
        "name_en": "Thick Fat",
    },
    {
        "id": 48,
        "name_ja": "はやおき",
        "name_en": "Early Bird",
    },
    {
        "id": 49,
        "name_ja": "ほのおのからだ",
        "name_en": "Flame Body",
    },
    {
        "id": 50,
        "name_ja": "にげあし",
        "name_en": "Run Away",
    },
    {
        "id": 51,
        "name_ja": "するどいめ",
        "name_en": "Keen Eye",
    },
    {
        "id": 52,
        "name_ja": "かいりきバサミ",
        "name_en": "Hyper Cutter",
    },
    {
        "id": 53,
        "name_ja": "ものひろい",
        "name_en": "Pickup",
    },
    {
        "id": 54,
        "name_ja": "なまけ",
        "name_en": "Truant",
    },
    {
        "id": 55,
        "name_ja": "はりきり",
        "name_en": "Hustle",
    },
    {
        "id": 56,
        "name_ja": "メロメロボディ",
        "name_en": "Cute Charm",
    },
    {
        "id": 57,
        "name_ja": "プラス",
        "name_en": "Plus",
    },
    {
        "id": 58,
        "name_ja": "マイナス",
        "name_en": "Minus",
    },
    {
        "id": 59,
        "name_ja": "てんきや",
        "name_en": "Forecast",
    },
    {
        "id": 60,
        "name_ja": "ねんちゃく",
        "name_en": "Sticky Hold",
    },
    {
        "id": 61,
        "name_ja": "だっぴ",
        "name_en": "Shed Skin",
    },
    {
        "id": 62,
        "name_ja": "こんじょう",
        "name_en": "Guts",
    },
    {
        "id": 63,
        "name_ja": "ふしぎなうろこ",
        "name_en": "Marvel Scale",
    },
    {
        "id": 64,
        "name_ja": "ヘドロえき",
        "name_en": "Liquid Ooze",
    },
    {
        "id": 65,
        "name_ja": "しんりょく",
        "name_en": "Overgrow",
    },
    {
        "id": 66,
        "name_ja": "もうか",
        "name_en": "Blaze",
    },
    {
        "id": 67,
        "name_ja": "げきりゅう",
        "name_en": "Torrent",
    },
    {
        "id": 68,
        "name_ja": "むしのしらせ",
        "name_en": "Swarm",
    },
    {
        "id": 69,
        "name_ja": "いしあたま",
        "name_en": "Rock Head",
    },
    {
        "id": 70,
        "name_ja": "ひでり",
        "name_en": "Drought",
    },
    {
        "id": 71,
        "name_ja": "ありじごく",
        "name_en": "Arena Trap",
    },
    {
        "id": 72,
        "name_ja": "やるき",
        "name_en": "Vital Spirit",
    },
    {
        "id": 73,
        "name_ja": "しろいけむり",
        "name_en": "White Smoke",
    },
    {
        "id": 74,
        "name_ja": "ヨガパワー",
        "name_en": "Pure Power",
    },
    {
        "id": 75,
        "name_ja": "シェルアーマー",
        "name_en": "Shell Armor",
    },
    {
        "id": 76,
        "name_ja": "エアロック",
        "name_en": "Air Lock",
    },
    {
        "id": 77,
        "name_ja": "ちどりあし",
        "name_en": "Tangled Feet",
    },
    {
        "id": 78,
        "name_ja": "でんきエンジン",
        "name_en": "Motor Drive",
    },
    {
        "id": 79,
        "name_ja": "とうそうしん",
        "name_en": "Rivalry",
    },
    {
        "id": 80,
        "name_ja": "ふくつのこころ",
        "name_en": "Steadfast",
    },
    {
        "id": 81,
        "name_ja": "ゆきがくれ",
        "name_en": "Snow Cloak",
    },
    {
        "id": 82,
        "name_ja": "くいしんぼう",
        "name_en": "Gluttony",
    },
    {
        "id": 83,
        "name_ja": "いかりのつぼ",
        "name_en": "Anger Point",
    },
    {
        "id": 84,
        "name_ja": "かるわざ",
        "name_en": "Unburden",
    },
    {
        "id": 85,
        "name_ja": "たいねつ",
        "name_en": "Heatproof",
    },
    {
        "id": 86,
        "name_ja": "たんじゅん",
        "name_en": "Simple",
    },
    {
        "id": 87,
        "name_ja": "かんそうはだ",
        "name_en": "Dry Skin",
    },
    {
        "id": 88,
        "name_ja": "ダウンロード",
        "name_en": "Download",
    },
    {
        "id": 89,
        "name_ja": "てつのこぶし",
        "name_en": "Iron Fist",
    },
    {
        "id": 90,
        "name_ja": "ポイズンヒール",
        "name_en": "Poison Heal",
    },
    {
        "id": 91,
        "name_ja": "てきおうりょく",
        "name_en": "Adaptability",
    },
    {
        "id": 92,
        "name_ja": "スキルリンク",
        "name_en": "Skill Link",
    },
    {
        "id": 93,
        "name_ja": "うるおいボディ",
        "name_en": "Hydration",
    },
    {
        "id": 94,
        "name_ja": "サンパワー",
        "name_en": "Solar Power",
    },
    {
        "id": 95,
        "name_ja": "はやあし",
        "name_en": "Quick Feet",
    },
    {
        "id": 96,
        "name_ja": "ノーマルスキン",
        "name_en": "Normalize",
    },
    {
        "id": 97,
        "name_ja": "スナイパー",
        "name_en": "Sniper",
    },
    {
        "id": 98,
        "name_ja": "マジックガード",
        "name_en": "Magic Guard",
    },
    {
        "id": 99,
        "name_ja": "ノーガード",
        "name_en": "No Guard",
    },
    {
        "id": 100,
        "name_ja": "あとだし",
        "name_en": "Stall",
    },
    {
        "id": 101,
        "name_ja": "テクニシャン",
        "name_en": "Technician",
    },
    {
        "id": 102,
        "name_ja": "リーフガード",
        "name_en": "Leaf Guard",
    },
    {
        "id": 103,
        "name_ja": "ぶきよう",
        "name_en": "Klutz",
    },
    {
        "id": 104,
        "name_ja": "かたやぶり",
        "name_en": "Mold Breaker",
    },
    {
        "id": 105,
        "name_ja": "きょううん",
        "name_en": "Super Luck",
    },
    {
        "id": 106,
        "name_ja": "ゆうばく",
        "name_en": "Aftermath",
    },
    {
        "id": 107,
        "name_ja": "きけんよち",
        "name_en": "Anticipation",
    },
    {
        "id": 108,
        "name_ja": "よちむ",
        "name_en": "Forewarn",
    },
    {
        "id": 109,
        "name_ja": "てんねん",
        "name_en": "Unaware",
    },
    {
        "id": 110,
        "name_ja": "いろめがね",
        "name_en": "Tinted Lens",
    },
    {
        "id": 111,
        "name_ja": "フィルター",
        "name_en": "Filter",
    },
    {
        "id": 112,
        "name_ja": "スロースタート",
        "name_en": "Slow Start",
    },
    {
        "id": 113,
        "name_ja": "きもったま",
        "name_en": "Scrappy",
    },
    {
        "id": 114,
        "name_ja": "よびみず",
        "name_en": "Storm Drain",
    },
    {
        "id": 115,
        "name_ja": "アイスボディ",
        "name_en": "Ice Body",
    },
    {
        "id": 116,
        "name_ja": "ハードロック",
        "name_en": "Solid Rock",
    },
    {
        "id": 117,
        "name_ja": "ゆきふらし",
        "name_en": "Snow Warning",
    },
    {
        "id": 118,
        "name_ja": "みつあつめ",
        "name_en": "Honey Gather",
    },
    {
        "id": 119,
        "name_ja": "おみとおし",
        "name_en": "Frisk",
    },
    {
        "id": 120,
        "name_ja": "すてみ",
        "name_en": "Reckless",
    },
    {
        "id": 121,
        "name_ja": "マルチタイプ",
        "name_en": "Multitype",
    },
    {
        "id": 122,
        "name_ja": "フラワーギフト",
        "name_en": "Flower Gift",
    },
    {
        "id": 123,
        "name_ja": "ナイトメア",
        "name_en": "Bad Dreams",
    },
    {
        "id": 124,
        "name_ja": "わるいてぐせ",
        "name_en": "Pickpocket",
    },
    {
        "id": 125,
        "name_ja": "ちからずく",
        "name_en": "Sheer Force",
    },
    {
        "id": 126,
        "name_ja": "あまのじゃく",
        "name_en": "Contrary",
    },
    {
        "id": 127,
        "name_ja": "きんちょうかん",
        "name_en": "Unnerve",
    },
    {
        "id": 128,
        "name_ja": "まけんき",
        "name_en": "Defiant",
    },
    {
        "id": 129,
        "name_ja": "よわき",
        "name_en": "Defeatist",
    },
    {
        "id": 130,
        "name_ja": "のろわれボディ",
        "name_en": "Cursed Body",
    },
    {
        "id": 131,
        "name_ja": "いやしのこころ",
        "name_en": "Healer",
    },
    {
        "id": 132,
        "name_ja": "フレンドガード",
        "name_en": "Friend Guard",
    },
    {
        "id": 133,
        "name_ja": "くだけるよろい",
        "name_en": "Weak Armor",
    },
    {
        "id": 134,
        "name_ja": "ヘヴィメタル",
        "name_en": "Heavy Metal",
    },
    {
        "id": 135,
        "name_ja": "ライトメタル",
        "name_en": "Light Metal",
    },
    {
        "id": 136,
        "name_ja": "マルチスケイル",
        "name_en": "Multiscale",
    },
    {
        "id": 137,
        "name_ja": "どくぼうそう",
        "name_en": "Toxic Boost",
    },
    {
        "id": 138,
        "name_ja": "ねつぼうそう",
        "name_en": "Flare Boost",
    },
    {
        "id": 139,
        "name_ja": "しゅうかく",
        "name_en": "Harvest",
    },
    {
        "id": 140,
        "name_ja": "テレパシー",
        "name_en": "Telepathy",
    },
    {
        "id": 141,
        "name_ja": "ムラっけ",
        "name_en": "Moody",
    },
    {
        "id": 142,
        "name_ja": "ぼうじん",
        "name_en": "Overcoat",
    },
    {
        "id": 143,
        "name_ja": "どくしゅ",
        "name_en": "Poison Touch",
    },
    {
        "id": 144,
        "name_ja": "さいせいりょく",
        "name_en": "Regenerator",
    },
    {
        "id": 145,
        "name_ja": "はとむね",
        "name_en": "Big Pecks",
    },
    {
        "id": 146,
        "name_ja": "すなかき",
        "name_en": "Sand Rush",
    },
    {
        "id": 147,
        "name_ja": "ミラクルスキン",
        "name_en": "Wonder Skin",
    },
    {
        "id": 148,
        "name_ja": "アナライズ",
        "name_en": "Analytic",
    },
    {
        "id": 149,
        "name_ja": "イリュージョン",
        "name_en": "Illusion",
    },
    {
        "id": 150,
        "name_ja": "かわりもの",
        "name_en": "Imposter",
    },
    {
        "id": 151,
        "name_ja": "すりぬけ",
        "name_en": "Infiltrator",
    },
    {
        "id": 152,
        "name_ja": "ミイラ",
        "name_en": "Mummy",
    },
    {
        "id": 153,
        "name_ja": "じしんかじょう",
        "name_en": "Moxie",
    },
    {
        "id": 154,
        "name_ja": "せいぎのこころ",
        "name_en": "Justified",
    },
    {
        "id": 155,
        "name_ja": "びびり",
        "name_en": "Rattled",
    },
    {
        "id": 156,
        "name_ja": "マジックミラー",
        "name_en": "Magic Bounce",
    },
    {
        "id": 157,
        "name_ja": "そうしょく",
        "name_en": "Sap Sipper",
    },
    {
        "id": 158,
        "name_ja": "いたずらごころ",
        "name_en": "Prankster",
    },
    {
        "id": 159,
        "name_ja": "すなのちから",
        "name_en": "Sand Force",
    },
    {
        "id": 160,
        "name_ja": "てつのトゲ",
        "name_en": "Iron Barbs",
    },
    {
        "id": 161,
        "name_ja": "ダルマモード",
        "name_en": "Zen Mode",
    },
    {
        "id": 162,
        "name_ja": "しょうりのほし",
        "name_en": "Victory Star",
    },
    {
        "id": 163,
        "name_ja": "ターボブレイズ",
        "name_en": "Turboblaze",
    },
    {
        "id": 164,
        "name_ja": "テラボルテージ",
        "name_en": "Teravolt",
    },
    {
        "id": 165,
        "name_ja": "アロマベール",
        "name_en": "Aroma Veil",
    },
    {
        "id": 166,
        "name_ja": "フラワーベール",
        "name_en": "Flower Veil",
    },
    {
        "id": 167,
        "name_ja": "ほおぶくろ",
        "name_en": "Cheek Pouch",
    },
    {
        "id": 168,
        "name_ja": "へんげんじざい",
        "name_en": "Protean",
    },
    {
        "id": 169,
        "name_ja": "ファーコート",
        "name_en": "Fur Coat",
    },
    {
        "id": 170,
        "name_ja": "マジシャン",
        "name_en": "Magician",
    },
    {
        "id": 171,
        "name_ja": "ぼうだん",
        "name_en": "Bulletproof",
    },
    {
        "id": 172,
        "name_ja": "かちき",
        "name_en": "Competitive",
    },
    {
        "id": 173,
        "name_ja": "がんじょうあご",
        "name_en": "Strong Jaw",
    },
    {
        "id": 174,
        "name_ja": "フリーズスキン",
        "name_en": "Refrigerate",
    },
    {
        "id": 175,
        "name_ja": "スイートベール",
        "name_en": "Sweet Veil",
    },
    {
        "id": 176,
        "name_ja": "バトルスイッチ",
        "name_en": "Stance Change",
    },
    {
        "id": 177,
        "name_ja": "はやてのつばさ",
        "name_en": "Gale Wings",
    },
    {
        "id": 178,
        "name_ja": "メガランチャー",
        "name_en": "Mega Launcher",
    },
    {
        "id": 179,
        "name_ja": "くさのけがわ",
        "name_en": "Grass Pelt",
    },
    {
        "id": 180,
        "name_ja": "きょうせい",
        "name_en": "Symbiosis",
    },
    {
        "id": 181,
        "name_ja": "かたいツメ",
        "name_en": "Tough Claws",
    },
    {
        "id": 182,
        "name_ja": "フェアリースキン",
        "name_en": "Pixilate",
    },
    {
        "id": 183,
        "name_ja": "ぬめぬめ",
        "name_en": "Gooey",
    },
    {
        "id": 184,
        "name_ja": "スカイスキン",
        "name_en": "Aerilate",
    },
    {
        "id": 185,
        "name_ja": "おやこあい",
        "name_en": "Parental Bond",
    },
    {
        "id": 186,
        "name_ja": "ダークオーラ",
        "name_en": "Dark Aura",
    },
    {
        "id": 187,
        "name_ja": "フェアリーオーラ",
        "name_en": "Fairy Aura",
    },
    {
        "id": 188,
        "name_ja": "オーラブレイク",
        "name_en": "Aura Break",
    },
    {
        "id": 189,
        "name_ja": "はじまりのうみ",
        "name_en": "Primordial Sea",
    },
    {
        "id": 190,
        "name_ja": "おわりのだいち",
        "name_en": "Desolate Land",
    },
    {
        "id": 191,
        "name_ja": "デルタストリーム",
        "name_en": "Delta Stream",
    },
    {
        "id": 192,
        "name_ja": "じきゅうりょく",
        "name_en": "Stamina",
    },
    {
        "id": 193,
        "name_ja": "にげごし",
        "name_en": "Wimp Out",
    },
    {
        "id": 194,
        "name_ja": "ききかいひ",
        "name_en": "Emergency Exit",
    },
    {
        "id": 195,
        "name_ja": "みずがため",
        "name_en": "Water Compaction",
    },
    {
        "id": 196,
        "name_ja": "ひとでなし",
        "name_en": "Merciless",
    },
    {
        "id": 197,
        "name_ja": "リミットシールド",
        "name_en": "Shields Down",
    },
    {
        "id": 198,
        "name_ja": "はりこみ",
        "name_en": "Stakeout",
    },
    {
        "id": 199,
        "name_ja": "すいほう",
        "name_en": "Water Bubble",
    },
    {
        "id": 200,
        "name_ja": "はがねつかい",
        "name_en": "Steelworker",
    },
    {
        "id": 201,
        "name_ja": "ぎゃくじょう",
        "name_en": "Berserk",
    },
    {
        "id": 202,
        "name_ja": "ゆきかき",
        "name_en": "Slush Rush",
    },
    {
        "id": 203,
        "name_ja": "えんかく",
        "name_en": "Long Reach",
    },
    {
        "id": 204,
        "name_ja": "うるおいボイス",
        "name_en": "Liquid Voice",
    },
    {
        "id": 205,
        "name_ja": "ヒーリングシフト",
        "name_en": "Triage",
    },
    {
        "id": 206,
        "name_ja": "エレキスキン",
        "name_en": "Galvanize",
    },
    {
        "id": 207,
        "name_ja": "サーフテール",
        "name_en": "Surge Surfer",
    },
    {
        "id": 208,
        "name_ja": "ぎょぐん",
        "name_en": "Schooling",
    },
    {
        "id": 209,
        "name_ja": "ばけのかわ",
        "name_en": "Disguise",
    },
    {
        "id": 210,
        "name_ja": "きずなへんげ",
        "name_en": "Battle Bond",
    },
    {
        "id": 211,
        "name_ja": "スワームチェンジ",
        "name_en": "Power Construct",
    },
    {
        "id": 212,
        "name_ja": "ふしょく",
        "name_en": "Corrosion",
    },
    {
        "id": 213,
        "name_ja": "ぜったいねむり",
        "name_en": "Comatose",
    },
    {
        "id": 214,
        "name_ja": "じょおうのいげん",
        "name_en": "Queenly Majesty",
    },
    {
        "id": 215,
        "name_ja": "とびだすなかみ",
        "name_en": "Innards Out",
    },
    {
        "id": 216,
        "name_ja": "おどりこ",
        "name_en": "Dancer",
    },
    {
        "id": 217,
        "name_ja": "バッテリー",
        "name_en": "Battery",
    },
    {
        "id": 218,
        "name_ja": "もふもふ",
        "name_en": "Fluffy",
    },
    {
        "id": 219,
        "name_ja": "ビビッドボディ",
        "name_en": "Dazzling",
    },
    {
        "id": 220,
        "name_ja": "ソウルハート",
        "name_en": "Soul-Heart",
    },
    {
        "id": 221,
        "name_ja": "カーリーヘアー",
        "name_en": "Tangling Hair",
    },
    {
        "id": 222,
        "name_ja": "レシーバー",
        "name_en": "Receiver",
    },
    {
        "id": 223,
        "name_ja": "かがくのちから",
        "name_en": "Power of Alchemy",
    },
    {
        "id": 224,
        "name_ja": "ビーストブースト",
        "name_en": "Beast Boost",
    },
    {
        "id": 225,
        "name_ja": "ＡＲシステム",
        "name_en": "RKS System",
    },
    {
        "id": 226,
        "name_ja": "エレキメイカー",
        "name_en": "Electric Surge",
    },
    {
        "id": 227,
        "name_ja": "サイコメイカー",
        "name_en": "Psychic Surge",
    },
    {
        "id": 228,
        "name_ja": "ミストメイカー",
        "name_en": "Misty Surge",
    },
    {
        "id": 229,
        "name_ja": "グラスメイカー",
        "name_en": "Grassy Surge",
    },
    {
        "id": 230,
        "name_ja": "メタルプロテクト",
        "name_en": "Full Metal Body",
    },
    {
        "id": 231,
        "name_ja": "ファントムガード",
        "name_en": "Shadow Shield",
    },
    {
        "id": 232,
        "name_ja": "プリズムアーマー",
        "name_en": "Prism Armor",
    },
    {
        "id": 233,
        "name_ja": "ブレインフォース",
        "name_en": "Neuroforce",
    },
    {
        "id": 234,
        "name_ja": "ふとうのけん",
        "name_en": "Intrepid Sword",
    },
    {
        "id": 235,
        "name_ja": "ふくつのたて",
        "name_en": "Dauntless Shield",
    },
    {
        "id": 236,
        "name_ja": "リベロ",
        "name_en": "Libero",
    },
    {
        "id": 237,
        "name_ja": "たまひろい",
        "name_en": "Ball Fetch",
    },
    {
        "id": 238,
        "name_ja": "わたげ",
        "name_en": "Cotton Down",
    },
    {
        "id": 239,
        "name_ja": "スクリューおびれ",
        "name_en": "Propeller Tail",
    },
    {
        "id": 240,
        "name_ja": "ミラーアーマー",
        "name_en": "Mirror Armor",
    },
    {
        "id": 241,
        "name_ja": "うのミサイル",
        "name_en": "Gulp Missile",
    },
    {
        "id": 242,
        "name_ja": "すじがねいり",
        "name_en": "Stalwart",
    },
    {
        "id": 243,
        "name_ja": "じょうききかん",
        "name_en": "Steam Engine",
    },
    {
        "id": 244,
        "name_ja": "パンクロック",
        "name_en": "Punk Rock",
    },
    {
        "id": 245,
        "name_ja": "すなはき",
        "name_en": "Sand Spit",
    },
    {
        "id": 246,
        "name_ja": "こおりのりんぷん",
        "name_en": "Ice Scales",
    },
    {
        "id": 247,
        "name_ja": "じゅくせい",
        "name_en": "Ripen",
    },
    {
        "id": 248,
        "name_ja": "アイスフェイス",
        "name_en": "Ice Face",
    },
    {
        "id": 249,
        "name_ja": "パワースポット",
        "name_en": "Power Spot",
    },
    {
        "id": 250,
        "name_ja": "ぎたい",
        "name_en": "Mimicry",
    },
    {
        "id": 251,
        "name_ja": "バリアフリー",
        "name_en": "Screen Cleaner",
    },
    {
        "id": 252,
        "name_ja": "はがねのせいしん",
        "name_en": "Steely Spirit",
    },
    {
        "id": 253,
        "name_ja": "ほろびのボディ",
        "name_en": "Perish Body",
    },
    {
        "id": 254,
        "name_ja": "さまようたましい",
        "name_en": "Wandering Spirit",
    },
    {
        "id": 255,
        "name_ja": "ごりむちゅう",
        "name_en": "Gorilla Tactics",
    },
    {
        "id": 256,
        "name_ja": "かがくへんかガス",
        "name_en": "Neutralizing Gas",
    },
    {
        "id": 257,
        "name_ja": "パステルベール",
        "name_en": "Pastel Veil",
    },
    {
        "id": 258,
        "name_ja": "はらぺこスイッチ",
        "name_en": "Hunger Switch",
    },
    {
        "id": 259,
        "name_ja": "クイックドロウ",
        "name_en": "Quick Draw",
    },
    {
        "id": 260,
        "name_ja": "ふかしのこぶし",
        "name_en": "Unseen Fist",
    },
    {
        "id": 261,
        "name_ja": "きみょうなくすり",
        "name_en": "Curious Medicine",
    },
    {
        "id": 262,
        "name_ja": "トランジスタ",
        "name_en": "Transistor",
    },
    {
        "id": 263,
        "name_ja": "りゅうのあぎと",
        "name_en": "Dragon’s Maw",
    },
    {
        "id": 264,
        "name_ja": "しろのいななき",
        "name_en": "Chilling Neigh",
    },
    {
        "id": 265,
        "name_ja": "くろのいななき",
        "name_en": "Grim Neigh",
    },
    {
        "id": 266,
        "name_ja": "じんばいったい",
        "name_en": "As One",
    },
    {
        "id": 267,
        "name_ja": "じんばいったい",
        "name_en": "As One",
    },
    {
        "id": 268,
        "name_ja": "とれないにおい",
        "name_en": "Lingering Aroma",
    },
    {
        "id": 269,
        "name_ja": "こぼれダネ",
        "name_en": "Seed Sower",
    },
    {
        "id": 270,
        "name_ja": "ねつこうかん",
        "name_en": "Thermal Exchange",
    },
    {
        "id": 271,
        "name_ja": "いかりのこうら",
        "name_en": "Anger Shell",
    },
    {
        "id": 272,
        "name_ja": "きよめのしお",
        "name_en": "Purifying Salt",
    },
    {
        "id": 273,
        "name_ja": "こんがりボディ",
        "name_en": "Well-Baked Body",
    },
    {
        "id": 274,
        "name_ja": "かぜのり",
        "name_en": "Wind Rider",
    },
    {
        "id": 275,
        "name_ja": "ばんけん",
        "name_en": "Guard Dog",
    },
    {
        "id": 276,
        "name_ja": "いわはこび",
        "name_en": "Rocky Payload",
    },
    {
        "id": 277,
        "name_ja": "ふうりょくでんき",
        "name_en": "Wind Power",
    },
    {
        "id": 278,
        "name_ja": "マイティチェンジ",
        "name_en": "Zero to Hero",
    },
    {
        "id": 279,
        "name_ja": "しれいとう",
        "name_en": "Commander",
    },
    {
        "id": 280,
        "name_ja": "でんきにかえる",
        "name_en": "Electromorphosis",
    },
    {
        "id": 281,
        "name_ja": "こだいかっせい",
        "name_en": "Protosynthesis",
    },
    {
        "id": 282,
        "name_ja": "クォークチャージ",
        "name_en": "Quark Drive",
    },
    {
        "id": 283,
        "name_ja": "おうごんのからだ",
        "name_en": "Good as Gold",
    },
    {
        "id": 284,
        "name_ja": "わざわいのうつわ",
        "name_en": "Vessel of Ruin",
    },
    {
        "id": 285,
        "name_ja": "わざわいのつるぎ",
        "name_en": "Sword of Ruin",
    },
    {
        "id": 286,
        "name_ja": "わざわいのおふだ",
        "name_en": "Tablets of Ruin",
    },
    {
        "id": 287,
        "name_ja": "わざわいのたま",
        "name_en": "Beads of Ruin",
    },
    {
        "id": 288,
        "name_ja": "ひひいろのこどう",
        "name_en": "Orichalcum Pulse",
    },
    {
        "id": 289,
        "name_ja": "ハドロンエンジン",
        "name_en": "Hadron Engine",
    },
    {
        "id": 290,
        "name_ja": "びんじょう",
        "name_en": "Opportunist",
    },
    {
        "id": 291,
        "name_ja": "はんすう",
        "name_en": "Cud Chew",
    },
    {
        "id": 292,
        "name_ja": "きれあじ",
        "name_en": "Sharpness",
    },
    {
        "id": 293,
        "name_ja": "そうだいしょう",
        "name_en": "Supreme Overlord",
    },
    {
        "id": 294,
        "name_ja": "きょうえん",
        "name_en": "Costar",
    },
    {
        "id": 295,
        "name_ja": "どくげしょう",
        "name_en": "Toxic Debris",
    },
    {
        "id": 296,
        "name_ja": "テイルアーマー",
        "name_en": "Armor Tail",
    },
    {
        "id": 297,
        "name_ja": "どしょく",
        "name_en": "Earth Eater",
    },
    {
        "id": 298,
        "name_ja": "きんしのちから",
        "name_en": "Mycelium Might",
    },
    {
        "id": 299,
        "name_ja": "しんがん",
        "name_en": "Mind’s Eye",
    },
    {
        "id": 301,
        "name_ja": "おもてなし",
        "name_en": "Hospitality",
    },
    {
        "id": 302,
        "name_ja": "どくのくさり",
        "name_en": "Toxic Chain",
    },
    {
        "id": 303,
        "name_ja": "おもかげやどし",
        "name_en": "Embody Aspect",
    },
    {
        "id": 304,
        "name_ja": "テラスチェンジ",
        "name_en": "Tera Shift",
    },
    {
        "id": 305,
        "name_ja": "テラスシェル",
        "name_en": "Tera Shell",
    },
    {
        "id": 306,
        "name_ja": "ゼロフォーミング",
        "name_en": "Teraform Zero",
    },
    {
        "id": 307,
        "name_ja": "どくくぐつ",
        "name_en": "Poison Puppeteer",
    }
] as Array<Ability>;

export default ability_list;
